import dynamic from 'next/dynamic';

const esadirComponents = {
    Capcalera: { dynamicComponent: dynamic(() => import(`components/corporatiu/Menu`)) },
    Destacat: { dynamicComponent: dynamic(() => import(`components/esadir/Destacat`)) },
    Menu: { dynamicComponent: dynamic(() => import(`components/esadir/Menu`)) },
    Fila: { dynamicComponent: dynamic(() => import(`components/esadir/Fila`)) },
    Peu: { dynamicComponent: dynamic(() => import(`components/corporatiu/Peu`)) }
};

export { esadirComponents };
